import { useEffect } from "react";

const ScrollDepthTracking = () => {
  useEffect(() => {
    const thresholds = [25, 50, 75, 100];
    const fired = new Set();

    const handleScroll = () => {
      const scrollTop = window.scrollY;
      const docHeight = document.documentElement.scrollHeight - window.innerHeight;
      const scrollPercent = Math.round((scrollTop / docHeight) * 100);

      thresholds.forEach((threshold) => {
        if (scrollPercent >= threshold && !fired.has(threshold)) {
          window.trackGoogleAnalyticsEvent("scroll_depth", {
            scroll_percent: threshold,
            page_path: window.location.pathname,
          });
          fired.add(threshold);
        }
      });

      if (fired.size === thresholds.length) {
        window.removeEventListener("scroll", handleScroll);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return null;
};

export default ScrollDepthTracking;
